$(function () {
    $('.upbtn').click(
        function () {
            $('html,body').animate({ scrollTop: '0px' }, 800);
        }
    );
});